/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"

class ProductsError extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.reloadPage = this.reloadPage.bind(this);
  }

  reloadPage() {
    // Clear any cookies / preferences
    $.removeCookie('product_listings_per_page');
    // Reload page without using cache
    window.location.reload(true);
  }

  render() {
    const { assets, b2bPhoneNumber, customerServicesEmail } = this.props;
    return (
      <div className="products-error">
        <div className="row-fluid">
          <div className="span12">
            <h1>
              Sorry, we are currently experiencing technical difficulties.
              Please reload the page or try again later.
            </h1>
            <button className="btn" onClick={this.reloadPage}>
              Reload Page
            </button>
            <p>Alternatively, get in touch with our customer service team</p>
            <ul className="no-results-list">
              <li>
                <img src={assets.icons.phone_red} className="icon" alt="" />
                You can also call <strong>{b2bPhoneNumber}</strong> to talk to
                an advisor.
                <br />
                Lines are open from 8am-8pm Monday-Friday.
              </li>
              <li>
                <img src={assets.icons.chat_red} className="icon" alt="" />
                For immediate assistance please use our online chat.
                <br />
                Open from 8am-8pm Monday-Friday.
              </li>
              <li>
                <img src={assets.icons.marker_red} className="icon" alt="" />
                If you would like to talk to someone in person.
                <br />
                Use our friendly store finder.
              </li>
              <li>
                <img src={assets.icons.email_red} className="icon" alt="" />
                We are also contactable by email if your enquiry is out
                <br />
                of hours at{' '}
                <a href={`mailto:${customerServicesEmail}`}>
                  <strong>{customerServicesEmail}</strong>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductsError;
